import { keepPreviousData, useQuery, type UseQueryOptions } from '@tanstack/vue-query';
import type { Ref } from 'vue';
import ApiRequest from '@/plugins/store/actions/api/ApiRequest';
import { Dashboard } from '@/types';

const DEFAULT_OPTIONS: UseQueryOptions<any> = {
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 5, // 5 minutes
};

export type StudyPeriodDashboardPayload = {
    animalGroupId: string;
    categoryIds: number[];
    studyPeriodIds: number[];
    favoriteTeamIds: number[];
    growthReferenceId: number | null;
};

export const queryKeys = {
    getDashboardRoot: ['dashboards', 'study-periods'],
    getDashboard: (payload: Ref<StudyPeriodDashboardPayload>) => [...queryKeys.getDashboardRoot, payload],
};

export function useStudyPeriodDashboard(payload: Ref<StudyPeriodDashboardPayload>, options: UseQueryOptions<{ charts: Dashboard; tables: Dashboard }> = {}) {
    return useQuery<{ charts: Dashboard; tables: Dashboard }>({
        queryKey: queryKeys.getDashboard(payload),
        queryFn: () => {
            let params = '';

            params += `animal_group_id=${payload.value.animalGroupId}`;

            if (payload.value.categoryIds.length > 0) {
                params += `&category_options=${payload.value.categoryIds.join(',')}`;
            }

            if (payload.value.studyPeriodIds.length > 0) {
                params += `&study_periods=${payload.value.studyPeriodIds.join(',')}`;
            }

            if (payload.value.favoriteTeamIds.length > 0) {
                params += `&favorites=${payload.value.favoriteTeamIds.join(',')}`;
            }

            if (payload.value.growthReferenceId) {
                params += `&growth_reference=${payload.value.growthReferenceId.toString()}`;
            }

            return new ApiRequest().send('get', `monitor/study-periods/analysis?${params}`, {});
        },
        placeholderData: keepPreviousData,
        ...DEFAULT_OPTIONS,
        ...options,
    });
}
